import { createFileRoute, notFound } from '@tanstack/react-router'
import { authRepository } from '@/data/adapters/api/auth.api'
import type { Client, Organization, User } from '@/modules/shared/types'

export const Route = createFileRoute('/$orgSlug/onboarding/$clientSlug')({
  validateSearch: (raw: Record<string, unknown>): { connect?: boolean } => ({
    connect:
      raw['connect'] === true || raw['connect'] === 'true' || raw['connect'] === '1'
        ? true
        : undefined,
  }),
  beforeLoad: async ({ params, context }) => {
    const { org, currentUser } = context as { org: Organization; currentUser: User }
    const clients = await authRepository.getClients(org.id)
    const client = clients.find((c) => c.slug === params.clientSlug)
    if (!client) throw notFound()
    return { org, client, currentUser } satisfies {
      org: Organization
      client: Client
      currentUser: User
    }
  },
})
